import { render, staticRenderFns } from "./OrganizacionArbol.vue?vue&type=template&id=3a5db2f4&scoped=true"
import script from "./OrganizacionArbol.vue?vue&type=script&lang=js"
export * from "./OrganizacionArbol.vue?vue&type=script&lang=js"
import style0 from "./OrganizacionArbol.vue?vue&type=style&index=0&id=3a5db2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5db2f4",
  null
  
)

export default component.exports